import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { catchError, map, of } from 'rxjs';

export const onlyAuthUserGuard: CanActivateChildFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const accessToken: string | null = route.queryParamMap.get('access');

    // If the access token is present, authenticate the user
    if (accessToken) {
        return authService.authenticate(accessToken).pipe(
            map((response) => {
                if (response.token) {
                    return router.createUrlTree(['/']);
                }
                return router.createUrlTree(['/not-authorized']);
            }),
            catchError(() => of(router.createUrlTree(['/not-authorized'])))
        );
        // If the access token is not present, check if the user is authenticated
    } else if (authService.isAuthenticated()) {
        return of(true);
    }

    return of(router.createUrlTree(['/not-authorized']));
};
